import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

// file = { src: "/api/path", name: "x.pdf", downloadSrc?: "/api/original" } | null
export const FilePreviewDialog = ({ file, onClose }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file) { setUrl(null); return undefined; }
    let objUrl = null;
    api.get(file.src, { responseType: "blob" })
      .then((r) => {
        const isPdf = (file.name || "").toLowerCase().endsWith(".pdf") || r.data.type === "application/pdf";
        objUrl = URL.createObjectURL(isPdf ? new Blob([r.data], { type: "application/pdf" }) : r.data);
        setUrl(objUrl);
      })
      .catch((e) => { toast.error(apiError(e)); onClose(); });
    return () => { if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [file]); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async () => {
    let href = url;
    if (file.downloadSrc) {
      try { const r = await api.get(file.downloadSrc, { responseType: "blob" }); href = URL.createObjectURL(r.data); }
      catch (e) { toast.error(apiError(e, "Téléchargement impossible.")); return; }
    }
    const a = document.createElement("a");
    a.href = href; a.download = file.name || "document.pdf"; a.click();
  };

  return (
    <Dialog open={!!file} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col p-4" data-testid="file-preview-dialog">
        <DialogHeader className="flex flex-row items-center justify-between pr-8">
          <DialogTitle className="text-base truncate">{file?.name || "Document"}</DialogTitle>
          {url && (
            <Button size="sm" variant="outline" onClick={download} data-testid="file-preview-download-btn">
              <Download className="w-4 h-4 mr-1.5" /> Télécharger
            </Button>
          )}
        </DialogHeader>
        <div className="flex-1 rounded-md border bg-slate-50 overflow-hidden">
          {url ? (
            <iframe src={url} title={file?.name || "Document"} className="w-full h-full" data-testid="file-preview-iframe" />
          ) : (
            <div className="h-full flex items-center justify-center text-slate-500 text-sm">
              <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Chargement…
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
